<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button v-if="source === 'hotel'" round icon="el-icon-back" @click="$emit('redirect', productId)">返回住宿訂單</el-button>
    </div>

    <div class="content-wrapper">
      <h2 class="title">選擇付款方式</h2>

      <el-row :gutter="20" type="flex" justify="center">
        <el-col :xs="24" :sm="10" :md="8">
          <div class="payment-card" @click="handleSelect('single')">
            <div class="icon-circle">
              <BaseIcon name="money-bill-wave-alt" icon-style="fal" />
            </div>
            <h3 class="card-title">單次付款</h3>
            <p class="card-desc">一次付清所有金額</p>
          </div>
        </el-col>

        <el-col v-if="paymentInfo.paymentMethods.includes('Installment')" :xs="24" :sm="10" :md="8">
          <div class="payment-card disabled" @click="handleSelect('installment')">
            <div class="icon-circle">
              <BaseIcon name="puzzle" icon-style="fal" />
            </div>
            <h3 class="card-title">分期付款</h3>
            <p class="card-desc">分期支付金額</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step1Frequency',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
    source: {
      type: String,
      default: () => ({}),
    },
    productId: {
      type: String,
      default: () => ({}),
    },
  },
  methods: {
    handleSelect(type) {
      // type 會傳入 'single' 或 'installment'
      this.$router
        .push({
          // path 或 name 擇一即可，既然你原本就在這一頁，可以用 path 抓當前路徑
          path: this.$route.path,
          query: {
            ...this.$route.query, // 保留原本網址可能有的其他 query (如果有)
            frequency: type, // 加入你想要的參數
          },
        })
        .catch((err) => {
          // 捕捉重複點擊相同路由導致的 NavigationDuplicated 報錯
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-selection-container {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;

  .header-actions {
    margin-bottom: 40px;
  }

  .content-wrapper {
    text-align: center;
    max-width: 1000px;
    margin: 0 auto;

    .title {
      font-size: 1.5rem;
      color: #333;
      margin-bottom: 40px;
      font-weight: 500;
    }
  }

  .payment-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 60px 20px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
      border-color: #ea6a2a; // 橘色邊框增強感
    }

    .icon-circle {
      width: 100px;
      height: 100px;
      border: 2px solid #ea6a2a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      color: #ea6a2a;
      margin-bottom: 20px;
    }

    .card-title {
      font-size: 1.25rem;
      color: #2c3e50;
      margin: 0 0 12px 0;
      font-weight: 600;
    }

    .card-desc {
      font-size: 0.95rem;
      color: #909399;
      margin: 0;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
      background-color: #fafafa;
    }
  }
}
</style>
